// Display only. Times travel as 'HH:MM' and dates as 'YYYY-MM-DD', which is
// what the server sends and what the inputs read.

export const toMinutes = (t) => {
  if (!t) return null;
  const parts = String(t).split(':');
  return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
};

export const fromMinutes = (m) => {
  const total = ((m % 1440) + 1440) % 1440;
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
};

// A 12 hour clock, which is how the couple reads their own day. What is
// stored and sent stays on the 24 hour clock, so an event running past
// midnight is still placed without reading an am or a pm.
export const fmtTime = (t) => {
  const m = toMinutes(t);
  if (m === null || Number.isNaN(m)) return '';
  const h24 = Math.floor(m / 60) % 24;
  const h = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h}:${String(m % 60).padStart(2, '0')} ${h24 < 12 ? 'am' : 'pm'}`;
};

const asDate = (iso) => new Date(`${iso}T00:00:00`);

export const fmtDatePill = (iso) =>
  iso ? asDate(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) : '';

export const fmtWeekday = (iso) =>
  iso ? asDate(iso).toLocaleDateString('en-GB', { weekday: 'long' }) : '';

export const fmtDateLong = (iso) =>
  iso
    ? asDate(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
    : '';

/**
 * The end of an event in minutes from its own day's midnight, rolled past it
 * when the event runs overnight: a sangeet from 22:00 to 01:00 ends at 1500,
 * not at 60, or every comparison against it reads backwards.
 */
export const endMinutes = (start, end) => {
  const a = toMinutes(start);
  const b = toMinutes(end);
  if (a === null || b === null || Number.isNaN(a) || Number.isNaN(b)) return b;
  return b < a ? b + 1440 : b;
};

// Duration in hours, to one decimal, for the guidance line.
export const durationHours = (start, end) => {
  const a = toMinutes(start);
  const b = endMinutes(start, end);
  if (a === null || b === null || Number.isNaN(a) || Number.isNaN(b)) return null;
  return Math.round(((b - a) / 60) * 10) / 10;
};
